import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import heroImage from '../../images/employess.png';

const Hero = ({ onStartLearningClick }) => {
  return (
    <div className="hero">
      <div className="hero-content">
        <h1>Grow your skills, advance your career</h1>
        <p>Access all the learning resources you need to excel at CriticalRiver</p>
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={onStartLearningClick}>Start Learning</button>
        </div>
      </div>
      <div className="hero-image" style={{backgroundImage: `url(${heroImage})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
        {/* Placeholder for the image */}
      </div>
    </div>
  );
};

export default Hero;
